import { format, parseISO } from 'date-fns';

export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';
  try {
    const date = parseISO(dateString);
    return format(date, 'dd.MM.yyyy');
  } catch {
    return '-';
  }
};
